import Swiper from 'swiper/bundle';

export default function toggleSwiperActivityAreaPosts(enable, instance) {
    const postsContainer = document.querySelector('.block-activity-area .posts');
    const thumbsContainer = document.querySelector('.block-activity-area .thumbs');
    const postItems = document.querySelectorAll('.block-activity-area .item');
    const thumbItems = document.querySelectorAll('.block-activity-area .thumb');

    if (postsContainer && thumbsContainer && postItems.length && thumbItems.length) {
        if (enable) {
            if (!instance.swiperPosts && !instance.swiperThumbs) {
                postsContainer.classList.add('swiper');
                thumbsContainer.classList.add('swiper');
                postItems.forEach(item => item.classList.add('swiper-slide'));
                thumbItems.forEach(item => item.classList.add('swiper-slide'));

                instance.swiperThumbs = new Swiper(".thumbs.swiper", {
                    spaceBetween: 0,
                    slidesPerView: 1,
                    watchSlidesVisibility: true,
                    watchSlidesProgress: true,
                    navigation: {
                        nextEl: ".block-activity-area .swiper-next",
                        prevEl: ".block-activity-area .swiper-prev",
                    },
                    allowTouchMove: false,
                    simulateTouch: false,
                });

                instance.swiperPosts = new Swiper(".posts.swiper", {
                    spaceBetween: 0,
                    slidesPerView: 1,
                    thumbs: {
                        swiper: instance.swiperThumbs,
                    },
                    navigation: {
                        nextEl: ".block-activity-area .swiper-next",
                        prevEl: ".block-activity-area .swiper-prev",
                    },
                });

                instance.swiperThumbs.on('click', function (swiper) {
                    const clickedIndex = swiper.clickedIndex;
                    if (clickedIndex !== undefined) {
                        instance.swiperPosts.slideTo(clickedIndex);
                    }
                }.bind(instance));
            }
        } else {
            if (instance.swiperPosts && instance.swiperThumbs) {
                instance.swiperPosts.destroy(true, true);
                instance.swiperThumbs.destroy(true, true);
                instance.swiperPosts = null;
                instance.swiperThumbs = null;

                postsContainer.classList.remove('swiper');
                thumbsContainer.classList.remove('swiper');
                postItems.forEach(item => item.classList.remove('swiper-slide'));
                thumbItems.forEach(item => item.classList.remove('swiper-slide'));

                forceReflow(postsContainer);
                forceReflow(thumbsContainer);
            }

            if (postItems.length > 0 && thumbItems.length > 0) {
                postItems[0].classList.add('active');
                thumbItems[0].classList.add('active');

                postItems.forEach((item, index) => {
                    item.addEventListener('mouseenter', () => {
                        setActiveItem(index);
                    });
                });
            }
        }
    }
}

function setActiveItem(index) {
    const postItems = document.querySelectorAll('.block-activity-area .item');
    const thumbItems = document.querySelectorAll('.block-activity-area .thumb');

    postItems.forEach((item, i) => {
        if (i === index) {
            item.classList.add('active');
        } else {
            item.classList.remove('active');
        }
    });

    thumbItems.forEach((item, i) => {
        if (i === index) {
            item.classList.add('active');
        } else {
            item.classList.remove('active');
        }
    });
}

function forceReflow(element) {
    element.getBoundingClientRect();
}
